import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { registerEnum } from '@adornis/baseql/metadata/register.js';
import { Language } from '@adornis/internationalization/language-iso639-2.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { LMSCoursePage } from './LMSCoursePage.js';

registerEnum({
  name: 'Language',
  enum: Language,
});

@Entity()
export class LMSCourse extends MongoEntity {
  static override _class = 'LMSCourse';
  static override _collectionName = 'lms_courses';

  @validate(nonOptional())
  @Field(() => String)
  title: Maybe<string>;

  @Field(() => String)
  description: Maybe<string>;

  @Field(() => Language)
  language: Maybe<keyof typeof Language>;

  @Field(() => Int, { default: v => v ?? 90 })
  passingScorePercent: Maybe<number>;

  @Field(() => Int)
  maxAttempts: Maybe<number>;

  @Field(() => Date)
  archivedAt: Maybe<Date>;

  @Field(() => Date)
  deletedAt: Maybe<Date>;

  @Field(() => Date, { default: v => v ?? new Date() })
  createdAt: Maybe<Date>;

  @DataLoadedField(() => [LMSCoursePage], ({ _id }) => ({ courseId: _id }))
  pages: Maybe<LMSCoursePage[]>;
}
